/**
 * LocationVenueRequestService
 * Service for LocationVenueRequest entity operations
 * Route: api/locationvenuerequests
 * Controller: LocationVenueRequestsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * LocationVenueRequestService
 * Handles location venue request CRUD operations
 * Maps to /api/locationvenuerequests endpoint
 */
export class LocationVenueRequestService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LocationVenueRequestService.DEFAULT_SERVICE_PATH,
            basePath: LocationVenueRequestService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Delete a location venue request by its composite key (VenueID + RequestID)
     * DELETE /api/locationvenuerequests/{venueId}/{requestId}
     * @param venueId - Venue ID
     * @param requestId - Request ID
     * @returns True if deleted successfully
     */
    async deleteByKey(venueId, requestId) {
        const response = await this.deleteByKeyRaw(venueId, requestId);
        return response.success;
    }
    /**
     * Delete a location venue request by its composite key (raw)
     * @param venueId - Venue ID
     * @param requestId - Request ID
     * @returns ResponseData (success/fail)
     */
    deleteByKeyRaw(venueId, requestId) {
        const endpoint = this.getEndpoint('deleteByKey', `${venueId}/${requestId}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
LocationVenueRequestService.DEFAULT_SERVICE_PATH = 'meetings';
LocationVenueRequestService.BASE_PATH = 'api/locationvenuerequests';
//# sourceMappingURL=LocationVenueRequestService.js.map